import moment from "moment-timezone";

export function listItemDateLabel(dateTime) {
  return I18n.t("list_items.date_label", {date: moment(dateTime).format("LL")});
}
